export const SERVICE_PRICING_UNIT_OPTIONS = [
  { label: '元/月', value: 'month' },
  { label: '元/天', value: 'day' }
]
